import _jsx from "@babel/runtime/helpers/jsx";

var _Icon, _FormattedMessage;

import React, { memo, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PageHelmet from 'components/PageHelmet';
import ResponsiveMenuWrapper from 'components/ResponsiveMenuWrapper';
import { META_FOR_RVK_PAGE } from 'constants/index';
import { useSeoMeta, useWebPageSchema, useMetaPage } from 'hooks';
import { getLocaleUrlPath, getAbsoluteMinfinLink } from 'utils';
import { Wrapper, Banner, MainInfoWrapper, LogoWrapper, Logo, Img, Name, ButtonsWrapper, LinkToReview, Icon } from './styles';

function OrganizationPageHeader(_ref) {
  var banner = _ref.backgroundImage,
      fullLogo = _ref.fullLogo,
      menu = _ref.menu,
      slug = _ref.slug,
      name = _ref.name,
      nameP = _ref.nameP,
      nameG = _ref.nameG,
      products = _ref.products;

  var _useIntl = useIntl(),
      locale = _useIntl.locale;

  var _useSeoMeta = useSeoMeta(META_FOR_RVK_PAGE, {
    bank: nameP,
    nameG: nameG
  }),
      pageTitle = _useSeoMeta.pageTitle,
      metaTitle = _useSeoMeta.metaTitle,
      metaDescription = _useSeoMeta.metaDescription;

  var reviewHref = useMemo(function () {
    return getAbsoluteMinfinLink("".concat(getLocaleUrlPath(locale), "/company/").concat(slug, "/review/add/"));
  }, [locale, slug]);
  var meta = useMetaPage();
  var pageSchema = useWebPageSchema({
    '@type': 'ItemList',
    name: pageTitle,
    itemListElement: products.slice(0, 6).map(function (el) {
      return {
        '@context': 'https://schema.org/',
        '@type': 'BankAccount',
        name: el.productName,
        provider: {
          '@type': 'BankOrCreditUnion',
          name: name
        }
      };
    })
  }, metaTitle, metaDescription);
  var pageScripts = useMemo(function () {
    return [{
      type: 'application/ld+json',
      innerHTML: pageSchema
    }];
  }, [pageSchema]);
  return /*#__PURE__*/_jsx(Wrapper, {}, void 0, /*#__PURE__*/_jsx(PageHelmet, {
    pageTitle: pageTitle,
    metaTitle: metaTitle,
    metaDescription: metaDescription,
    meta: meta,
    script: pageScripts
  }), /*#__PURE__*/_jsx(Banner, {
    img: banner
  }), /*#__PURE__*/_jsx(MainInfoWrapper, {}, void 0, /*#__PURE__*/_jsx(LogoWrapper, {}, void 0, /*#__PURE__*/_jsx(Logo, {}, void 0, /*#__PURE__*/_jsx(Img, {
    src: getAbsoluteMinfinLink(fullLogo)
  })), /*#__PURE__*/_jsx(Name, {}, void 0, pageTitle)), /*#__PURE__*/_jsx(ButtonsWrapper, {}, void 0, /*#__PURE__*/_jsx(LinkToReview, {
    href: reviewHref,
    rel: "nofollow"
  }, void 0, _Icon || (_Icon = /*#__PURE__*/_jsx(Icon, {
    name: "plus"
  })), _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    id: "addReview"
  }))))), !!menu && /*#__PURE__*/_jsx(ResponsiveMenuWrapper, {
    menu: menu
  }));
}

OrganizationPageHeader.defaultProps = {
  backgroundImage: '',
  fullLogo: '',
  menu: [],
  products: [],
  slug: '',
  name: '',
  nameP: '',
  nameG: ''
};
export default /*#__PURE__*/memo(OrganizationPageHeader);